import React from "react";
import { type RouteObject } from "react-router-dom";
import { AutoGenerateReport } from "@/features/auto-generate-report";
import { Dashboard } from "@/features/dashboard";
import { DataIntegrationMonitoring } from "@/features/data-integration-monitoring";
import { EarlyWarningSystem } from "@/features/early-warning-system";
import { EmotionKeywords } from "@/features/emotion-keywords";
import { EmotionPreview } from "@/features/emotion-preview";
import { HomeNew } from "@/features/home-new";
import { KeywordSearch } from "@/features/keyword-search";
import { RegionalMonitoring } from "@/features/regional-monitoring";
import { SentimentAnalysis } from "@/features/sentiment-analysis";

const PanelCustomize = React.lazy(
  () => import("@/page/panel-customize/PanelCustomizePage.tsx"),
);

export const RenewRoute: RouteObject[] = [
  {
    path: "home-new",
    element: <HomeNew />,
  },
  {
    path: "dashboard",
    element: <Dashboard />,
  },
  {
    path: "data-integration-monitoring",
    element: <DataIntegrationMonitoring />,
  },
  {
    path: "early-warning-system",
    element: <EarlyWarningSystem />,
  },
  {
    path: "sentiment-analysis",
    element: <SentimentAnalysis />,
  },
  {
    path: "regional-monitoring",
    element: <RegionalMonitoring />,
  },
  {
    path: "auto-generate-report",
    element: <AutoGenerateReport />,
  },
  {
    path: "emotion-keywords",
    element: <EmotionKeywords />,
  },
  {
    path: "emotion-preview",
    element: <EmotionPreview />,
  },
  {
    path: "keyword-search",
    element: <KeywordSearch />,
  },
  {
    path: "panel-customize",
    element: <PanelCustomize />,
  },
];
